// Generated by scripts/import-bible-sections.mjs. Do not edit manually.
export const passageSectionAsset = {
  "assetUrl": "/bible/passage-sections.b2aac7a372705bb4.json.gz",
  "packageHash": "b2aac7a372705bb4c25f639723b77bac9580984cbd613642dc5b8921475829dd",
  "sectionCount": 3096,
  "sourceUrl": "https://berean.bible/downloads.htm",
  "license": "Public domain"
} as const;
